// extracted by mini-css-extract-plugin
export var displayNone = "_pa-6";
export var imgContainer = "_pa-2";
export var overflowHidden = "_pa-3";
export var productInfoCardButtonContainer = "_pa-5";
export var productTitleText = "_pa-4";
export var rightArrow = "_pa-1";
export var rightArrowContainer = "_pa-0";